export default __webpack_public_path__ + "static/media/Aura-Egg__58.f76f47bd.png";